import { HStack, Text } from '@chakra-ui/react';
import { CallWarningIcon, useCyclicVisibility } from '@halo/ui-chat-react';
import { MyTrans } from '@halo/ui-react';

export interface CallMainPanelNotificationProps {
  status: CallNetWorkStatus;
}

export enum CallNetWorkStatus {
  RECONNECTING = 4,
  ERROR = 5,
}

export function CallMainPanelNotification({ status }: CallMainPanelNotificationProps) {
  const { show, checkShow } = useCyclicVisibility();

  const isReconnecting = useMemo(() => status === CallNetWorkStatus.RECONNECTING, [status]);

  const content = useMemo(() => {
    switch (status) {
      case CallNetWorkStatus.RECONNECTING:
        return show ? (
          <>
            <CallWarningIcon />
            <Text>
              <MyTrans i18nKey="calls.netErrReconnecting" />
            </Text>
          </>
        ) : (
          <></>
        );
      case CallNetWorkStatus.ERROR:
        return (
          <>
            <CallWarningIcon />
            <Text>
              <MyTrans i18nKey="calls.netErrPleaseCheck" />
            </Text>
          </>
        );
      default:
        return null;
    }
  }, [show, status]);

  useEffect(() => {
    checkShow(!isReconnecting);
  }, [checkShow, isReconnecting]);

  if (isReconnecting && !show) {
    return null;
  }

  return (
    <HStack
      pos="absolute"
      top="0"
      w="full"
      justifyContent="center"
      alignItems="center"
      gap="2.5"
      color="white"
      fontSize="sm"
      backdropFilter="blur(48px)"
      p="3"
      bg="rgba(255, 0, 21, 0.2)"
      zIndex={100}
    >
      {content}
    </HStack>
  );
}

export default CallMainPanelNotification;
